module.exports = {
      id: "album-usage",
      viewBox: "0 0 25.602 21.762",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#album",
      toString: function () {
        return this.url;
      }
    }